import { Component,ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { GraficasProvider } from '../../providers/graficas/graficas'
import { Chart } from 'chart.js';
import { ClientesProvider } from '../../providers/clientes/clientes'
import { AuthService } from '../../providers/auth-service'
import { CompaniasProvider } from '../../providers/companias/companias'
import * as papa from 'papaparse'
import { UsuariosProvider } from '../../providers/usuarios/usuarios'
import { NUBE_AWS } from '../../config/url.servicio';

@IonicPage()
@Component({
  selector: 'page-graficas',
  templateUrl: 'graficas.html',
  providers: [ AuthService ]
})
export class GraficasPage {
  @ViewChild('barCanvas') barCanvas;
  @ViewChild('barCanvasafn') barCanvasafn;
  @ViewChild('doughnutCanvas') doughnutCanvas;
  @ViewChild('lineCanvas') lineCanvas;
  @ViewChild('doughnutCanvasUno') doughnutCanvasUno;
  @ViewChild('doughnutCanvasDos') doughnutCanvasDos;
  @ViewChild('doughnutCanvasTres') doughnutCanvasTres;

  barChart: any;
  doughnutChart: any;
  doughnutChartUno: any;
  doughnutChartDos: any;
  doughnutChartTres: any;
  lineChart: any;
  data = []
  datos = ""
  labels = ""
  dataReal = [{valorReal:-1}]
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  parsedData:any
  parsedDataReal:any
  parseDataHeader:any

  parsedDataSemanalesPorDia:any
  parsedDataRealSemanalesPorDia:any
  parseDataHeaderSemanalesPorDia:any

  parsedDataMensualesPorSemana:any
  parsedDataRealMensualesPorSemana:any
  parseDataHeaderMensualesPorSemana:any

  parsedDataAnualesPorMes:any
  parsedDataRealAnualesPorMes:any
  parseDataHeaderAnualesPorMes:any

  parsedDataproducto:any
  parsedDataRealproducto:any
  parseDataHeaderproducto:any
  companiasId : any = null

  constructor(public navCtrl: NavController, public navParams: NavParams,
              public servicio:GraficasProvider,
              public utils:ClientesProvider,
              public auth: AuthService,
              public servicioCompania:CompaniasProvider,
              public serviciUsuario:UsuariosProvider,
              public alertCtrl:AlertController) {


                this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo','usuariosId','companiasId'])
                .then((val)=>{
                  if(val){
                    this.nombreCompaniaHeader = val['nombreCompania']
                    this.nombreCargoHeader = val['nombreCargo']
                    let codigo = val['usuariosId']
                    this.companiasId = val['companiasId']
                    this.serviciUsuario.buscarUsuarioAdministrador(codigo).subscribe((data)=>{
                      data = NUBE_AWS ? JSON.parse(data['_body']).data[0]: data
                      if(!data[0].administrador){
                        this.showAlert('No tiene permiso para ver los informes')
                        this.navCtrl.setRoot('HomePage');
                      }
                    },(error)=>{

                      this.navCtrl.setRoot('HomePage');
                    })
                  }
                })
  }

  showAlert(msj) {
    let alert = this.alertCtrl.create({
      title: 'Verifique..',
      subTitle: msj,
      buttons: ['OK']
    });
    alert.present();
  }

  ionViewDidLoad() {

    this.buscarVentasDiarias()
    this.ventasSemanalesPorDia()
    this.ventasMensualesPorSemana()
    this.ventasAnualesPorMes()
    // this.buscarProductos()
  }

  buscarProductos(){
    this.servicio.buscarProductos()
    .subscribe((data)=>{

        let realvalorgrid = ''

        for(var i = 0; i< data[0].length;i++){

            if(i==0){
              realvalorgrid+= 'nombre,existenciasActuales,existenciasMinimas,valorVenta,productosId,nombreCompania' + '\n'
            }else{
              realvalorgrid+= data[0][i]['nombre']  + ',' + data[0][i]['existenciasActuales']   + ',' + data[0][i]['existenciasMinimas'] + ',' + data[0][i]['valorVenta'] + ',' + data[0][i]['productosId']  + ',' + data[0][i]['nombreCompania'] + '\n'
            }

        }
        this.parsedDataproducto = papa.parse(realvalorgrid).data

        this.parseDataHeaderproducto =  this.parsedDataproducto[0]
        this.parsedDataproducto.splice(0,1)
        this.parsedDataRealproducto = this.parsedDataproducto

    },error=>{
        console.log(error)
    })



  }

  buscarVentasDiarias(){
    this.servicioCompania.devolverVarios(['companiasId'])
    .then((val)=>{
      let companiasId = val['companiasId']

    this.servicio.buscarVentasDiarias(this.companiasId)
    .subscribe((data:any)=>{
      data = NUBE_AWS ? JSON.parse(data['_body']).data[0]: data
      // if(data.length == []){
      //   return
      // }
      if(data.length == 0){
        return
      }
        let valorinicial = []
        let valorfinal = []

        let realvalorgrid = ''
        let realvalorgridHeader = ''
        for(var i = 0; i< data.length;i++){
            valorinicial[i]= data[i]['valorVenta']

            valorfinal[i] = data[i]['horaVenta']
            if(i==0){
              realvalorgrid+= 'hora Venta,valor Venta' + '\n'
            }else{
              realvalorgrid+= data[i]['horaVenta']  + ',' + data[i]['valorVenta']  + '\n'
            }

        }

        this.parsedData = papa.parse(realvalorgrid).data

        this.parseDataHeader =  this.parsedData[0]
        this.parsedData.splice(0,1)
        this.parsedDataReal = this.parsedData


       this.graficas(valorinicial,valorfinal)
    },error=>{
        console.log(error)
    })
  })
  }

  trackByFn(index:any,item:any){
    return index;
  }

  descargarProducto(name:any){
    let csv = papa.unparse({
      fields: this.parseDataHeaderproducto,
      data: this.parsedDataRealproducto
    })

    var blob = new Blob([csv])
    var a = window.document.createElement("a")
    a.href = window.URL.createObjectURL(blob)
    a.download = name + '.csv'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  actualizarProducto(name:any){

   let   data = this.parsedDataRealproducto

   for(let i=0;i < data.length;i++){
      let producto: any = {
        existenciasMinimas: Number(data[i][2]),
        existenciasActuales: Number(data[i][1]),
        productosId: Number(data[i][4]),
        queHago: "A",
        nombreTabla: "productos",
        name: "dataDynamicCrud"
      }

     //?name=dataDynamicCrud&paisesId=${pais.paisesId}&codigoPais=${pais.codigoPais}&nombrePais=${pais.nombrePais}&nombreTabla=paises
     this.servicio.actualizarProducto(producto).subscribe((item)=>{
      console.log(item)
     },(error) => {
       console.log(error)
     })

   }

  }

  descargar(name:any){

    let csv = papa.unparse({
      fields: this.parseDataHeader,
      data: this.parsedDataReal
    })

    var blob = new Blob([csv])
    var a = window.document.createElement("a")
    a.href = window.URL.createObjectURL(blob)
    a.download = name + '.csv'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  descargarSemanal(name:any){

    let csv = papa.unparse({
      fields: this.parseDataHeaderSemanalesPorDia,
      data: this.parsedDataRealSemanalesPorDia
    })

    var blob = new Blob([csv])
    var a = window.document.createElement("a")
    a.href = window.URL.createObjectURL(blob)
    a.download = name + '.csv'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  descargarMensual(name:any){

    let csv = papa.unparse({
      fields: this.parseDataHeaderMensualesPorSemana,
      data: this.parsedDataRealMensualesPorSemana
    })

    var blob = new Blob([csv])
    var a = window.document.createElement("a")
    a.href = window.URL.createObjectURL(blob)
    a.download = name + '.csv'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  descargarAnual(name:any){

    let csv = papa.unparse({
      fields: this.parseDataHeaderAnualesPorMes,
      data: this.parsedDataRealAnualesPorMes
    })

    var blob = new Blob([csv])
    var a = window.document.createElement("a")
    a.href = window.URL.createObjectURL(blob)
    a.download = name + '.csv'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  ventasSemanalesPorDia(){
    this.servicioCompania.devolverVarios(['companiasId'])
    .then((val)=>{
      let companiasId = val['companiasId']

      this.servicio.buscarVentasSemanalesPorDias(companiasId)
      .subscribe((data)=>{
        data = NUBE_AWS ? JSON.parse(data['_body']).data[0]: data
        // if(data.length == []){
        //   return
        // }
        if(data.length == 0){
          return
        }
          let valorinicial = []
          let valorfinal = []

          let realvalorgrid = ''

          for(var i = 0; i< data.length;i++){
              valorinicial[i]= data[i]['valorVenta']

              valorfinal[i] = data[i]['fechaVenta']
              if(i==0){
                realvalorgrid+= 'Fecha Venta,valor Venta' + '\n'
              }else{
                realvalorgrid+= data[i]['fechaVenta']  + ',' + data[i]['valorVenta'] + '\n'
              }

          }

          this.parsedDataSemanalesPorDia = papa.parse(realvalorgrid).data

          this.parseDataHeaderSemanalesPorDia =  this.parsedDataSemanalesPorDia[0]
          this.parsedDataSemanalesPorDia.splice(0,1)
          this.parsedDataRealSemanalesPorDia = this.parsedDataSemanalesPorDia


          // for(var i = 0; i< data[0].length;i++){
          //     valorinicial[i]= data[0][i]['valorVenta']

          //     valorfinal[i] = data[0][i]['fechaVenta']

          // }
          this.graficaventasSemanalesPorDia(valorinicial,valorfinal)
      },error=>{
          console.log(error)
      })
    })

  }

  ventasMensualesPorSemana(){
    this.servicioCompania.devolverVarios(['companiasId'])
    .then((val)=>{
      let companiasId = val['companiasId']

    this.servicio.buscarventasMensualesPorSemanas(companiasId)
    .subscribe((data)=>{
      data = NUBE_AWS ? JSON.parse(data['_body']).data[0]: data
      // if(data.length == []){
      //   return
      // }
      if(data.length == 0){
        return
      }
        let valorinicial = []
        let valorfinal = []


        let realvalorgrid = ''

        for(var i = 0; i< data.length;i++){
          valorinicial[i]= data[i]['valorVenta']
          let valoruno = ""
          valoruno = data[i]['semanaDesde']
          valoruno = valoruno.substr(0,10)
          let valordos = ""
          valordos = data[i]['semanaHasta']
          valordos = valordos.substr(0,10)

          valorfinal[i] =`Desde ${valoruno} Hasta ${valordos}`
          if(data.length == 1 && i ==0){
            realvalorgrid+= 'Semana Desde  - Semana Hasta,valor Venta' + '\n'
            realvalorgrid+='Desde ' + valoruno + ' Hasta ' + valordos  + ',' + data[i]['valorVenta'] +  '\n'
          }else{
            if(i==0){
              realvalorgrid+= 'Semana Desde  - Semana Hasta,valor Venta' + '\n'
            }else{
              realvalorgrid+='Desde ' + valoruno + ' Hasta ' + valordos  + ',' + data[i]['valorVenta'] +  '\n'
            }
          }

      }




        this.parsedDataMensualesPorSemana = papa.parse(realvalorgrid).data

        this.parseDataHeaderMensualesPorSemana =  this.parsedDataMensualesPorSemana[0]
        this.parsedDataMensualesPorSemana.splice(0,1)
        this.parsedDataRealMensualesPorSemana = this.parsedDataMensualesPorSemana


        this.graficaMensualesPorSemana(valorinicial,valorfinal)
    },error=>{
        console.log(error)
    })
  })
  }

  ventasAnualesPorMes(){
    this.servicioCompania.devolverVarios(['companiasId'])
    .then((val)=>{
      let companiasId = val['companiasId']

    this.servicio.buscarventasAnualesPorMes(companiasId)
    .subscribe((data)=>{
      data = NUBE_AWS ? JSON.parse(data['_body']).data[0]: data
      // if(data.length == []){
      //   return
      // }
      if(data.length == 0){
        return
      }
        let valorinicial = []
        let valorfinal = []

        let realvalorgrid = ''

        for(var i = 0; i< data.length;i++){
            valorinicial[i]= data[i]['valorVenta']

            valorfinal[i] = data[i]['mesVenta']
            if(data.length == 1  && i ==0){
              realvalorgrid+= 'Mes Venta,valor Venta' + '\n'
              realvalorgrid+= data[i]['mesVenta']  + ',' + data[i]['valorVenta'] + '\n'
            }else{
              if(i==0){
                realvalorgrid+= 'Mes Venta,valor Venta' + '\n'
              }else{
                realvalorgrid+= data[i]['mesVenta']  + ',' + data[i]['valorVenta'] + '\n'
              }
            }


        }

        // if(realvalorgrid == "" && data[0].length ===undefined && data[0].valorVenta !== ""){

        //   let valor = data[0]
        //   realvalorgrid+= 'Mes Venta,valor Venta' + '\n'
        //       realvalorgrid+= valor.mesVenta  + ',' + valor.valorVenta + '\n'

        // }

        this.parsedDataAnualesPorMes = papa.parse(realvalorgrid).data

        this.parseDataHeaderAnualesPorMes =  this.parsedDataAnualesPorMes[0]
        this.parsedDataAnualesPorMes.splice(0,1)
        this.parsedDataRealAnualesPorMes = this.parsedDataAnualesPorMes

        // for(var i = 0; i< data[0].length;i++){
        //     valorinicial[i]= data[0][i]['valorVenta']

        //     valorfinal[i] = data[0][i]['mesVenta']

        // }
        this.graficaventasAnualesPorMes(valorinicial,valorfinal)
    },error=>{
        console.log(error)
    })
  })
  }

  groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
        const key = keyGetter(item);
        const collection = map.get(key);
        if (!collection) {
            map.set(key, [item]);
        } else {
            collection.push(item);
        }
    });
    return map;
}

graficas(datoss:any,labesl:any){

    this.doughnutChart = new Chart(this.doughnutCanvas.nativeElement, {

        type: 'bar',
        data: {
            labels: labesl,
            datasets: [{
                label: datoss,
                backgroundColor: ["#3e95cd", "#8e5ea2","#3cba9f","#e8c3b9","#c45850"],
                data:datoss,

            }]
        },
       options: {
    responsive: true,
    aspectRatio: 1,
    maintainaApectRatio: true,
    onResize: function () {
      if (window.innerWidth > 700) {
        this.legend.position = 'right';
        this.legend.aspectRatio = 1.4;
        this.legend.maintainaApectRatio = false;
      } else {
        this.legend.position = 'bottom';
        this.legend.aspectRatio = 1;
        this.legend.maintainaApectRatio = true;
      }
    },
    legend: {
      display: true,
      position: "top",
          title: {
      display: true,
      text: 'Ventas por hora'
    },
      labels: {

      }
    }
  }

    });

}


graficaventasSemanalesPorDia(datoss:any,labesl:any){

    this.doughnutChartUno = new Chart(this.doughnutCanvasUno.nativeElement, {
    // new Chart(document.getElementById("bar-chart"), {
        type: 'bar',
        data: {
          labels:labesl,
          datasets: [
            {
              label: datoss,
              backgroundColor: ["#3e95cd", "#8e5ea2","#3cba9f","#e8c3b9","#c45850"],
              data:datoss
            }
          ]
        },
        options: {
          legend: { display: true },
          title: {
            display: true,
            text: 'Ventas última Semana'
          }
        }
    // });
 });

}

graficaMensualesPorSemana(datoss:any,labesl:any){

    this.doughnutChartDos = new Chart(this.doughnutCanvasDos.nativeElement, {


    type: 'bar',
    data: {
      labels:labesl,
      datasets: [
        {
          label: datoss,
          backgroundColor: ["#3e95cd", "#8e5ea2","#3cba9f","#e8c3b9","#c45850"],
          data:datoss
        }
      ]
    },
    options: {
      legend: { display: true },
      title: {
        display: true,
        text: 'Ventas Mensuales'
      }
    }});
}

graficaventasAnualesPorMes(datoss:any,labesl:any){

    this.doughnutChartTres = new Chart(this.doughnutCanvasTres.nativeElement, {
        type: 'bar',
        data: {
          labels:labesl,
          datasets: [
            {
              label: datoss,
              backgroundColor: ["#3e95cd", "#8e5ea2","#3cba9f","#e8c3b9","#c45850"],
              data:datoss
            }
          ]
        },
        options: {
          legend: { display: true },
          title: {
            display: true,
            text: 'Ventas Anuales por mes'
          }
        }
    });

}



chat(){
    this.navCtrl.push('ChatPage');
}

buscarTodosLosValores(){

}
cerrarSession(){
    this.auth.logout()
    this.navCtrl.setRoot('LoginPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/graficas/graficas.ts